module.exports = __webpack_public_path__ + "img/maintenance.6e0e2631.svg";